import { z } from 'zod';
import { UserActivitySource } from '@/features/superAdmin/features/userActivities/types/superAdmin-userActivities-dto';

export const UserActivitiesPageFilterFormSchema = z.object({
    startDate: z.date().nullable().optional(),
    endDate: z.date().nullable().optional(),
    source: z.nativeEnum(UserActivitySource).nullable().optional(),
    userId: z.string().nullable().optional(),
    tenantId: z.string().nullable().optional(),
});

export type UserActivitiesPageFilterFormData = z.infer<typeof UserActivitiesPageFilterFormSchema>;
